// @ts-nocheck
import makeStyles from '@mui/styles/makeStyles';
import Chip from '@mui/material/Chip';
import type { Theme } from '@mui/material';

import IconExternalOrder from '@experimental-components/IconsComponents/ExternalOrder';
import IconDelivery from '@experimental-components/IconsComponents/Delivery';
import IconDineIn from '@experimental-components/IconsComponents/DineIn';
import IconPickUp from '@experimental-components/IconsComponents/PickUp';
import IconTakeOut from '@experimental-components/IconsComponents/TakeOut';

import { typeOrders } from 'utils/reportsFilters';

const iconComponents = {
  [typeOrders.PICK_UP]: IconPickUp,
  [typeOrders.DELIVERY]: IconDelivery,
  [typeOrders.DINE_IN]: IconDineIn,
  [typeOrders.TAKE_OUT]: IconTakeOut,
  [typeOrders.EXTERNAL]: IconExternalOrder,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    with: '100%',
    maxWidth: 132,
    minWidth: 132,
    height: '100%',
    maxHeight: 40,
    minHeight: 40,
    fontSize: 14,
    borderRadius: 100,
    backgroundColor: theme.palette.darkGrey[5],
    padding: theme.spacing(1),
  },
}));

interface Props {
  label: string;
  value: string;
}

function OrderTypeItem({ label, value, ...others }: Props) {
  const classes = useStyles();
  const IconComponent = iconComponents[value] ?? IconExternalOrder;

  return (
    <Chip classes={{ root: classes.root }} icon={<IconComponent size={16} />} label={label} size="small" {...others} />
  );
}

export default OrderTypeItem;
